/**
 * 入力履歴ナビゲーションの状態。
 * `index` が null のときは下書きを編集中（履歴を閲覧していない）。
 * 履歴閲覧中は `index` が履歴配列（古い→新しい順）の添字を指す。
 */
export interface HistoryNavState {
	index: number | null;
	/** 履歴閲覧を開始した時点の下書き。最新の次へ進んだとき復元する。 */
	savedDraft: string;
}

export const INITIAL_HISTORY_NAV: HistoryNavState = { index: null, savedDraft: "" };

export interface HistoryNavResult {
	state: HistoryNavState;
	text: string;
}

/**
 * 1つ前（より古い）履歴へ移動した結果を返す。
 * 下書き編集中なら最新の履歴に入り、その時点の下書きを保存する。
 */
export function historyPrevious(
	state: HistoryNavState,
	history: readonly string[],
	currentText: string,
): HistoryNavResult | null {
	if (history.length === 0) return null;
	if (state.index === null) {
		const index = history.length - 1;
		return { state: { index, savedDraft: currentText }, text: history[index] };
	}
	if (state.index > 0) {
		const index = state.index - 1;
		return { state: { ...state, index }, text: history[index] };
	}
	return null;
}

/**
 * 1つ後（より新しい）履歴へ移動した結果を返す。
 * 最新の履歴から更に進むと、保存しておいた下書きへ戻る。
 */
export function historyNext(
	state: HistoryNavState,
	history: readonly string[],
): HistoryNavResult | null {
	if (state.index === null) return null;
	if (state.index < history.length - 1) {
		const index = state.index + 1;
		return { state: { ...state, index }, text: history[index] };
	}
	return { state: INITIAL_HISTORY_NAV, text: state.savedDraft };
}
